import { render, staticRenderFns } from "./AccommodationRequests.vue?vue&type=template&id=c5df2ebc&scoped=true&"
import script from "./AccommodationRequests.vue?vue&type=script&lang=js&"
export * from "./AccommodationRequests.vue?vue&type=script&lang=js&"
import style0 from "./AccommodationRequests.vue?vue&type=style&index=0&id=c5df2ebc&prod&lang=scss&"
import style1 from "./AccommodationRequests.vue?vue&type=style&index=1&id=c5df2ebc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5df2ebc",
  null
  
)

export default component.exports